import { Observable, BehaviorSubject } from 'rxjs';
import { get, cloneDeep } from 'lodash';

declare interface ICommonDataService<T> {
	data$: BehaviorSubject<T>,
	init? (): Observable<any>,
	setData (data: T): void,
	getData (): T,
	setDataByPath (data, key: string): void,
	getDataByPath (path: string): any,
}

export abstract class CommonDataServiceClass<T = any> implements ICommonDataService<T> {
	data$ = new BehaviorSubject<T>(null);

	private data: T;

	setData (data: T): void {
		this.data = cloneDeep(data);
		this.data$.next(this.data);
	}

	getData (): T {
		return cloneDeep(this.data);
	}

	setDataByPath (data, key: string): void {
		this.data[key] = cloneDeep(data);
	}

	getDataByPath (path: string): any {
		return get(this.data, path);
	}
}
